import { useEffect, useState } from 'react';
import SideBar from '../../modules/sidebar/sidebar';
import Body from '../../modules/body/body';
import './Structure.css';
import Header from '../../modules/header/header';

import { useLocation, useNavigate } from 'react-router-dom';

function Structure() {

  const [page, setPage] = useState('');

  const location = useLocation();

  const {
    agente,
    propsPage,
    pedido,
    empresa,
    usuario
  } = location.state || {};

  const navigate = useNavigate();

  function navigateOnPages(page: string) {
    setPage(page);
  }

  useEffect(() => {

    validateSession();

    if (propsPage)
      navigateOnPages(propsPage);
    else
      navigateOnPages('indicadoresGraficos');

  }, [propsPage]);

  async function validateSession() {

    if (!localStorage.getItem('stbs')) {
      navigate('/');
    }
  }

  return (

    <div className="Structure">
      <SideBar navigateOnPages={navigateOnPages} />
      <div className="ContentArea">
        <Header />
        <div className="MainContent">
          <Body
            view={page}
            agenteState={agente}
            pedidoState={pedido}
            empresaState={empresa}
            usuarioState={usuario}
          />
        </div>
      </div>
    </div>
  );
}

export default Structure;